// extracted by mini-css-extract-plugin
export default {"carousel":"yE-z"};